import { initLazyLoad } from "@api/utils_2020";
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';
import('./pb23-carousel--products-leads.css');


const pb23CarouselProductsLeads = {
    init: function() {
        console.log(".pb23-carousel--products-leads: INIT");
        initLazyLoad();
        // Products (Sizes) Carousel 
        $('.pb23-carousel--products-leads').each(function(){
            var jsCarouselBannerContent = new Splide($(this).find('.jsCarouselProductsLeads')[0],{
                perPage: 5,
                perMove: 1,
                arrows: true,
                pagination: false,
                autoplay: false,
                gap: "0px",
                breakpoints: {
                    1280: {
                        perPage: 3
                    },
                    769: {
                        autoWidth: true,
                        perPage: 1,
                        gap: "0px",
                        arrows: false
                    }
                }
            }); 
            jsCarouselBannerContent.mount();
        });
    }
}
// initialize component
window.initializeComponent.push({ component: "pb23-carousel--products-leads", init: pb23CarouselProductsLeads.init });


export default() => {
    pb23CarouselProductsLeads.init();
}